<template>
  <v-footer padless class="home3-footer">
    <v-container>
      <v-row class="home3-footer__main py-8">
        <v-col cols="12" md="4" class="mb-6 mb-md-0">
          <div class="home3-footer__brand mb-4">
            <v-img
              src="@/assets/images/logos/watchon_logo.png"
              max-width="140"
              contain
            />
          </div>
          <p class="home3-footer__tagline">
            Safe, transparent school bus tracking for administrators, drivers, and families.
          </p>
          <a
            :href="playStoreUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="home3-footer__play-store"
            aria-label="Get WatchOn on Google Play"
          >
            <img
              src="@/assets/images/logos/google-play-badge.svg"
              alt="Get it on Google Play"
              class="home3-footer__play-store-badge"
            />
          </a>
        </v-col>

        <v-col cols="6" sm="4" md="2">
          <h4 class="home3-footer__heading">Product</h4>
          <ul class="home3-footer__links">
            <li><a href="#features" @click.prevent="$vuetify.goTo('#features')">Features</a></li>
            <li><a href="#about" @click.prevent="$vuetify.goTo('#about')">About</a></li>
            <li><a href="#how-it-works" @click.prevent="$vuetify.goTo('#how-it-works')">How It Works</a></li>
          </ul>
        </v-col>

        <v-col cols="6" sm="4" md="2">
          <h4 class="home3-footer__heading">Account</h4>
          <ul class="home3-footer__links">
            <li><router-link to="/login">{{ $t('Login') }}</router-link></li>
            <li><router-link to="/register">{{ $t('school_signup') }}</router-link></li>
          </ul>
        </v-col>

        <v-col cols="12" sm="4" md="4">
          <h4 class="home3-footer__heading">Legal</h4>
          <ul class="home3-footer__links">
            <li><router-link to="/privacy">Privacy Policy</router-link></li>
            <li><router-link to="/terms">Terms &amp; Conditions</router-link></li>
          </ul>
        </v-col>
      </v-row>

      <v-divider class="home3-footer__divider" />

      <div class="home3-footer__bottom d-flex flex-wrap align-center justify-space-between py-4">
        <span class="home3-footer__copy">
          &copy; {{ currentYear }} {{ systemName }}. All rights reserved.
        </span>
        <div class="home3-footer__social">
          <v-btn
            v-for="(social, i) in socials"
            :key="i"
            icon
            small
            :href="social.link"
            target="_blank"
            rel="noopener noreferrer"
            class="home3-footer__social-btn"
          >
            <v-icon small>{{ social.icon }}</v-icon>
          </v-btn>
        </div>
      </div>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  props: {
    systemName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      playStoreUrl: 'https://play.google.com/store/apps/details?id=net.corph.watchon.parent&pcampaignid=web_share',
      socials: [
        { icon: 'mdi-facebook', link: '#' },
        { icon: 'mdi-twitter', link: '#' },
        { icon: 'mdi-linkedin', link: '#' },
      ],
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
  },
}
</script>

<style lang="scss" scoped>
@import './home3-theme.scss';

.home3-footer {
  background: $home3-navy !important;
  color: rgba(255, 255, 255, 0.75);

  &__name {
    font-size: 1.05rem;
    font-weight: 600;
    color: #fff;
  }

  &__tagline {
    font-size: 0.9rem;
    line-height: 1.65;
    color: rgba(255, 255, 255, 0.6);
    max-width: 280px;
    margin: 0 0 1.25rem;
  }

  &__play-store {
    display: inline-block;
    line-height: 0;
    transition: opacity 0.2s ease, transform 0.2s ease;

    &:hover {
      opacity: 0.9;
      transform: translateY(-2px);
    }
  }

  &__play-store-badge {
    height: 44px;
    width: auto;
    display: block;
  }

  &__heading {
    font-size: 0.8rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #fff;
    margin-bottom: 1rem;
  }

  &__links {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      margin-bottom: 0.5rem;
    }

    a {
      font-size: 0.9rem;
      color: rgba(255, 255, 255, 0.65);
      text-decoration: none;
      transition: color 0.2s ease;

      &:hover {
        color: $home3-primary-light;
      }
    }
  }

  &__divider {
    border-color: rgba(255, 255, 255, 0.1) !important;
  }

  &__copy {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.5);
  }

  &__social-btn {
    color: rgba(255, 255, 255, 0.6) !important;

    &:hover {
      color: $home3-primary-light !important;
    }
  }
}
</style>
